import React, { useCallback, useEffect, useState } from "react";
import { Card, Col, Row, Table, Typography, Button, Modal, message } from "antd";
import { PAGINATION } from "../../../admin/_redux/constants";
import { DEFAULT_VALUE } from "../../../app/_redux/constants";
import _ from "lodash";
import {
  DeleteOutlined,
  EditOutlined,
  ExclamationCircleOutlined,
  PlusOutlined
} from "@ant-design/icons";
import services from "services";
import {
  get
} from "lodash";
import TripodModal from "./TripodModal";

const { Text } = Typography;
function TripodList({
  total,
  loading,
  dataSource,
  online,
  param,
  onChangeParam
}) {
  const CARD_STYLE = {
    borderRadius: "0.42rem",
    boxShadow: "0px 0px 30px 0px rgba(82, 63, 105, 0.05)"
  };
  const CARD_BODY_STYLE = {
    padding: "0px 10px 10px 10px"
  };
  const CARD_HEAD_STYLE = {
    padding: "0px 9px 0px 9px",
    borderBottom: "none"
  };
  const SNoStyle = {
    color: "#14a05b",
    fontWeight: "bold",
    display: "inline-block",
    textAlign: "center"
  };

  const [tripodModalConfig, setTripodModalConfig] = useState({
    visible: false,
    isCreate: true,
    dataSource: {}
  });

  const [tableConfig, setTableConfig] = useState(
    {
      current: 1,
      pageSize: 20,
    },
  );

  const columns = [
    {
      dataIndex: "stt",
      title: "STT",
      width: "3%",
      align: "center"
    },
    {
      dataIndex: "station",
      title: "Tên kho",
      width: "10%",
      render: (text, tripod) => {
        return (
          <Text>
            <span style={SNoStyle}>
              {_.get(tripod.station, "station_id", DEFAULT_VALUE)}
            </span>
            {" | " + `${_.get(tripod.station, "station_name", DEFAULT_VALUE)}`}
          </Text>
        );
      }
    },
    {
      dataIndex: "name",
      title: "Tên thiết bị",
      width: "10%",
      align: "center",
      render: name => name || "-"
    },
    {
      title: "SN",
      dataIndex: "device_id",
      width: "10%",
      align: "center",
      render: device_id => device_id || "-"
    },
    {
      title: "IP thiết bị",
      dataIndex: "connect_type",
      width: "10%",
      align: "center",
      render: (connect_type, record) => {
        let ip = "-";
        if (connect_type === 1) {
          ip = record.public_ip || "-";
        }
        if (connect_type === 2) {
          ip = record.local_ip || "-";
        }
        return ip;
      }
    },
    {
      title: "Số người",
      dataIndex: "total_profiles",
      width: "8%",
      align: "center",
      render: total_profiles => total_profiles || "-"
    },
    {
      title: "Số vân tay",
      dataIndex: "total_logs",
      width: "9%",
      align: "center",
      render: total_logs => total_logs || "-"
    },
    {
      title: "Device Model",
      dataIndex: "device_model",
      width: "10%",
      align: "center",
      render: device_model => device_model || "-"
    },
    {
      title: "Firmware Version",
      dataIndex: "firmware_version",
      width: "10%",
      align: "center",
      render: firmware_version => firmware_version || "-"
    },
    {
      title: "Trạng thái",
      dataIndex: "status",
      width: "10%",
      align: "center",
      render: (status, record) => (
        <Text>
          <i
            className={`fas fa-circle ${record.status === 0 ? "" : "text-primary"}`}/>{" "}
          {record.status === 0 ? "Offline" : "Online"}
        </Text>
      )
    },
    {
      key: "action",
      dataIndex: "action",
      title: "Hành động",
      align: "center",
      width: 50,
      render: (value, item, index) => {

        const openModal = () => {
          setTripodModalConfig(prev => {
            let next = { ...prev };
            next.isCreate = false;
            next.visible = true;
            next.dataSource = item;
            return next;
          });
        };

        const showDeleteConfirm = () => {
          Modal.confirm({
            title: "Xác nhận",
            icon: <ExclamationCircleOutlined />,
            okText: "Xác nhận",
            okType: "danger",
            cancelText: "Hủy",
            content: (
              <span>
                Xóa tripod
                <b className="text-danger ml-1">
                  {item.name} - {item.device_id}
                </b>
              </span>
            ),
            onOk() {
              services.TripodService.deleteTripod(item.id)
                .then(r => {
                  let success = get(r, "data.success");
                  if (success) {
                    message.success("Xóa tripod thành công.");
                    onChangeParam({
                      page: tableConfig.current,
                      size: tableConfig.pageSize
                    });
                  } else {
                    const resMessage = get(r, "data.message");
                    message.error(`Xóa tripod không thành công.${resMessage}`);
                  }
                })
                .catch(() =>
                  message.error("Xóa tripod không thành công. Vui lòng thử lại")
                );
            },
            onCancel() { }
          });
        };
        return (
          <div className="d-flex align-items-center justify-content-center">
            <EditOutlined onClick={openModal} className="text-primary mr-2" />
            <DeleteOutlined
              onClick={showDeleteConfirm}
              className="text-danger"
            />
          </div>
        );
      }
    }
  ];

  const onShowTripodModal = (isShow, isCreate = true) => {
    if (isShow === false) {
      onChangeParam({
        page: tableConfig.current,
        size: tableConfig.pageSize
      });

    }
    setTripodModalConfig(prev => ({
      ...prev,
      isCreate,
      visible: isShow,
      dataSource: undefined
    }));
  };

  return (
    <Card
      size="small"
      style={CARD_STYLE}
      bodyStyle={CARD_BODY_STYLE}
      headStyle={CARD_HEAD_STYLE}
      title={
        <Row className="w-100 d-flex justify-content-between" align="middle" gutter={[8]} justify="start">
          <Col>
            <Text>
              Tổng thiết bị: <Text className="text-dark">{total}&nbsp;</Text>
            </Text>
            <Text>
              Thiết bị hoạt động:&nbsp;
              <Text className="text-primary">{online}</Text>
            </Text>
          </Col>
          <Col className="d-flex justify-self-end">
            <Button
              className="d-flex justi align-items-center"
              type="primary"
              onClick={() => onShowTripodModal(true)}
              icon={<PlusOutlined />}
            >
              Thêm mới
            </Button>
          </Col>
        </Row>
      }
    >
      <Table
        loading={{
          spinning: loading,
          delay: 500
        }}
        rowKey="_id"
        bordered
        size="small"
        columns={columns}
        dataSource={dataSource}
        pagination={{
          pageSize: param.size,
          current: param.page,
          defaultPageSize: PAGINATION.page,
          total,
          showSizeChanger: true,
          onChange: (page, pageSize) => {
            onChangeParam({
              page: page,
              size: pageSize
            });
            setTableConfig({
              current: page,
              pageSize: pageSize
            })
          }
        }}
      />
      {tripodModalConfig.visible && (<TripodModal
        config={tripodModalConfig}
        onShowModal={onShowTripodModal}
      />)}
    </Card>
  );
}

export default React.memo(TripodList);
